import { classes } from 'html-classes';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

import Breadcrumbs from '~/components/Breadcrumbs/Breadcrumbs';
import { useGlobal } from '~/hooks/useGlobal';
import { BreadcrumbsItem } from '~/stores/CatalogStore';
import { userStore } from '~/stores/UserStore';

import MobileHeaderLayout from '../Main/MobileHeader/MobileHeaderLayout';
import MobileHeaderTitle from '../Main/MobileHeader/MobileHeaderTitle';
import { ROUTES } from '../Root/constants';

import { Balance } from './components/Balance';
import ShopButton from './components/Buttons/ShopButton';
import { HistoryList } from './components/History';
import { StepsSection } from './components/StepsSection';
import { Welcome } from './components/Welcome';
import styles from './LoyaltyProgram.module.scss';

const LoyaltyProgram = () => {
  const { isMobile } = useGlobal();
  const { t } = useTranslation();

  useEffect(() => {
    userStore.loyaltyPointsStore.getLoyaltyUserBalanceAndTransactions();
  }, []);

  return (
    <>
      <Helmet>
        <meta data-react-helmet="true" name="robots" content="index, follow" />
      </Helmet>
      <MobileHeaderLayout
        content={
          <MobileHeaderTitle text={t('loyalty:balance:companyPoints')} />
        }
      />

      <div className={classes(['content-layout', styles.pageWrapper])}>
        {!isMobile && (
          <Breadcrumbs
            items={
              [
                {
                  text: t('home'),
                  link: ROUTES.index,
                },
                {
                  text: t('loyalty:loyalityProgram'),
                  link: ROUTES.loyalty,
                },
              ].filter(Boolean) as BreadcrumbsItem[]
            }
          />
        )}
        <div className={styles.page}>
          <section className={classes([styles.balance, styles.container])}>
            <Welcome />
            <Balance />
          </section>
          <section className={classes([styles.info, styles.container])}>
            <StepsSection />
            <HistoryList />
          </section>
          <div
            className={classes([
              styles.ctaMobileContainer,
              styles.buttonContainer,
            ])}
          >
            <ShopButton />
          </div>
        </div>
      </div>
    </>
  );
};

export default observer(LoyaltyProgram);
